import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export interface CountryDial {
  name: string;
  iso: string;
  dial: string;
  flag: string;
}

export const COUNTRY_DIALS: CountryDial[] = [
  { name: "Maroc", iso: "MA", dial: "+212", flag: "🇲🇦" },
  { name: "France", iso: "FR", dial: "+33", flag: "🇫🇷" },
  { name: "Espagne", iso: "ES", dial: "+34", flag: "🇪🇸" },
  { name: "Italie", iso: "IT", dial: "+39", flag: "🇮🇹" },
  { name: "Royaume-Uni", iso: "GB", dial: "+44", flag: "🇬🇧" },
  { name: "Allemagne", iso: "DE", dial: "+49", flag: "🇩🇪" },
  { name: "Belgique", iso: "BE", dial: "+32", flag: "🇧🇪" },
  { name: "Pays-Bas", iso: "NL", dial: "+31", flag: "🇳🇱" },
  { name: "Suisse", iso: "CH", dial: "+41", flag: "🇨🇭" },
  { name: "Portugal", iso: "PT", dial: "+351", flag: "🇵🇹" },
  { name: "États-Unis", iso: "US", dial: "+1", flag: "🇺🇸" },
  { name: "Canada", iso: "CA", dial: "+1", flag: "🇨🇦" },
  { name: "Algérie", iso: "DZ", dial: "+213", flag: "🇩🇿" },
  { name: "Tunisie", iso: "TN", dial: "+216", flag: "🇹🇳" },
  { name: "Libye", iso: "LY", dial: "+218", flag: "🇱🇾" },
  { name: "Égypte", iso: "EG", dial: "+20", flag: "🇪🇬" },
  { name: "Mauritanie", iso: "MR", dial: "+222", flag: "🇲🇷" },
  { name: "Sénégal", iso: "SN", dial: "+221", flag: "🇸🇳" },
  { name: "Côte d'Ivoire", iso: "CI", dial: "+225", flag: "🇨🇮" },
  { name: "Mali", iso: "ML", dial: "+223", flag: "🇲🇱" },
  { name: "Nigéria", iso: "NG", dial: "+234", flag: "🇳🇬" },
  { name: "Afrique du Sud", iso: "ZA", dial: "+27", flag: "🇿🇦" },
  { name: "Autriche", iso: "AT", dial: "+43", flag: "🇦🇹" },
  { name: "Irlande", iso: "IE", dial: "+353", flag: "🇮🇪" },
  { name: "Danemark", iso: "DK", dial: "+45", flag: "🇩🇰" },
  { name: "Suède", iso: "SE", dial: "+46", flag: "🇸🇪" },
  { name: "Norvège", iso: "NO", dial: "+47", flag: "🇳🇴" },
  { name: "Finlande", iso: "FI", dial: "+358", flag: "🇫🇮" },
  { name: "Islande", iso: "IS", dial: "+354", flag: "🇮🇸" },
  { name: "Pologne", iso: "PL", dial: "+48", flag: "🇵🇱" },
  { name: "Tchéquie", iso: "CZ", dial: "+420", flag: "🇨🇿" },
  { name: "Slovaquie", iso: "SK", dial: "+421", flag: "🇸🇰" },
  { name: "Hongrie", iso: "HU", dial: "+36", flag: "🇭🇺" },
  { name: "Roumanie", iso: "RO", dial: "+40", flag: "🇷🇴" },
  { name: "Bulgarie", iso: "BG", dial: "+359", flag: "🇧🇬" },
  { name: "Grèce", iso: "GR", dial: "+30", flag: "🇬🇷" },
  { name: "Croatie", iso: "HR", dial: "+385", flag: "🇭🇷" },
  { name: "Slovénie", iso: "SI", dial: "+386", flag: "🇸🇮" },
  { name: "Serbie", iso: "RS", dial: "+381", flag: "🇷🇸" },
  { name: "Luxembourg", iso: "LU", dial: "+352", flag: "🇱🇺" },
  { name: "Malte", iso: "MT", dial: "+356", flag: "🇲🇹" },
  { name: "Chypre", iso: "CY", dial: "+357", flag: "🇨🇾" },
  { name: "Turquie", iso: "TR", dial: "+90", flag: "🇹🇷" },
  { name: "Russie", iso: "RU", dial: "+7", flag: "🇷🇺" },
  { name: "Ukraine", iso: "UA", dial: "+380", flag: "🇺🇦" },
  { name: "Arabie saoudite", iso: "SA", dial: "+966", flag: "🇸🇦" },
  { name: "Émirats arabes unis", iso: "AE", dial: "+971", flag: "🇦🇪" },
  { name: "Qatar", iso: "QA", dial: "+974", flag: "🇶🇦" },
  { name: "Koweït", iso: "KW", dial: "+965", flag: "🇰🇼" },
  { name: "Bahreïn", iso: "BH", dial: "+973", flag: "🇧🇭" },
  { name: "Oman", iso: "OM", dial: "+968", flag: "🇴🇲" },
  { name: "Jordanie", iso: "JO", dial: "+962", flag: "🇯🇴" },
  { name: "Liban", iso: "LB", dial: "+961", flag: "🇱🇧" },
  { name: "Israël", iso: "IL", dial: "+972", flag: "🇮🇱" },
  { name: "Inde", iso: "IN", dial: "+91", flag: "🇮🇳" },
  { name: "Chine", iso: "CN", dial: "+86", flag: "🇨🇳" },
  { name: "Japon", iso: "JP", dial: "+81", flag: "🇯🇵" },
  { name: "Corée du Sud", iso: "KR", dial: "+82", flag: "🇰🇷" },
  { name: "Australie", iso: "AU", dial: "+61", flag: "🇦🇺" },
  { name: "Nouvelle-Zélande", iso: "NZ", dial: "+64", flag: "🇳🇿" },
  { name: "Brésil", iso: "BR", dial: "+55", flag: "🇧🇷" },
  { name: "Argentine", iso: "AR", dial: "+54", flag: "🇦🇷" },
  { name: "Mexique", iso: "MX", dial: "+52", flag: "🇲🇽" },
  { name: "Chili", iso: "CL", dial: "+56", flag: "🇨🇱" },
  { name: "Colombie", iso: "CO", dial: "+57", flag: "🇨🇴" },
];

const LANG_TO_ISO: Record<string, string> = {
  fr: "FR",
  es: "ES",
  it: "IT",
  en: "GB",
  ar: "MA",
};

/** Longest dial code matching the start of the value. */
const splitPhone = (value: string) => {
  const trimmed = (value || "").trim();
  if (trimmed.startsWith("+")) {
    const matches = COUNTRY_DIALS.filter((c) => trimmed.startsWith(c.dial)).sort(
      (a, b) => b.dial.length - a.dial.length
    );
    if (matches.length > 0) {
      return {
        dial: matches[0].dial,
        iso: matches[0].iso,
        local: trimmed.slice(matches[0].dial.length).trim(),
      };
    }
  }
  return { dial: "", iso: "", local: trimmed };
};

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  required?: boolean;
  placeholder?: string;
  className?: string;
}

export const PhoneInput = ({
  value,
  onChange,
  id,
  required,
  placeholder = "6XX XXX XXX",
  className,
}: PhoneInputProps) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  // Country explicitly chosen by the user; survives an empty local part
  // (e.g. typing a leading "0") so the selector never silently resets.
  const [selectedIso, setSelectedIso] = useState("");

  const defaultIso = useMemo(() => {
    const lang = (i18n.language || "fr").slice(0, 2).toLowerCase();
    return LANG_TO_ISO[lang] || "MA";
  }, [i18n.language]);

  const parsed = splitPhone(value);
  const activeIso = parsed.iso || selectedIso || defaultIso;
  const active =
    COUNTRY_DIALS.find((c) => c.iso === activeIso) || COUNTRY_DIALS[0];

  const setLocal = (local: string) => {
    // Pasted full international number (e.g. "+33 6 12 34 56 78"):
    // detect its own country code instead of gluing it onto the selected prefix.
    if (local.trim().startsWith("+")) {
      const digits = local.replace(/[^\d+]/g, "").slice(0, 24);
      const match = COUNTRY_DIALS.filter((c) => digits.startsWith(c.dial)).sort(
        (a, b) => b.dial.length - a.dial.length
      )[0];
      if (match) {
        const rest = digits.slice(match.dial.length).replace(/^0+/, "");
        onChange(rest ? `${match.dial} ${rest}` : `${match.dial} `);
        return;
      }
    }
    const cleaned = local.replace(/[^0-9\s().-]/g, "").slice(0, 20);
    // Drop a leading "0" trunk prefix (e.g. "0612..." → "612...") so the
    // saved number stays valid with the country code.
    const normalized = cleaned.trimStart().replace(/^0+/, "");
    onChange(normalized ? `${active.dial} ${normalized}` : "");
  };

  const selectCountry = (country: CountryDial) => {
    setOpen(false);
    setSelectedIso(country.iso);
    const local = parsed.local;
    onChange(local ? `${country.dial} ${local}` : `${country.dial} `);
  };

  return (
    <div className={cn("flex gap-2", className)}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            type="button"
            variant="outline"
            role="combobox"
            aria-label="Indicatif pays"
            aria-expanded={open}
            className="h-10 shrink-0 gap-1 px-2 font-body font-normal bg-background"
          >
            <span className="text-base leading-none">{active.flag}</span>
            <span className="text-sm">{active.dial}</span>
            <ChevronsUpDown className="w-3.5 h-3.5 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="p-0 w-[280px] max-w-[95vw]" align="start">
          <Command>
            <CommandInput placeholder="Pays ou indicatif…" />
            <CommandList className="max-h-64">
              <CommandEmpty>Aucun pays trouvé</CommandEmpty>
              <CommandGroup>
                {COUNTRY_DIALS.map((country) => (
                  <CommandItem
                    key={country.iso}
                    value={`${country.name} ${country.dial} ${country.iso}`}
                    onSelect={() => selectCountry(country)}
                    className="cursor-pointer"
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        country.iso === active.iso ? "opacity-100" : "opacity-0"
                      )}
                    />
                    <span className="mr-2">{country.flag}</span>
                    <span className="truncate flex-1">{country.name}</span>
                    <span className="text-muted-foreground text-sm ml-2">
                      {country.dial}
                    </span>
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      <Input
        id={id}
        type="tel"
        inputMode="tel"
        required={required}
        placeholder={placeholder}
        value={parsed.local}
        onChange={(e) => setLocal(e.target.value)}
        className="bg-background border-border font-body rounded-lg"
      />
    </div>
  );
};

export default PhoneInput;
